import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const IMAGE =
  "https://images.unsplash.com/photo-1740907628172-acd27c2e1de8?auto=format&fit=crop&w=900&q=80";

export default function LocationTeaser() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12" data-testid="location-teaser">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="relative overflow-hidden"
            style={{ aspectRatio: "4/3" }}
            data-testid="location-teaser-image"
          >
            <img
              src={IMAGE}
              alt="Atelier 77 – Historischer Bauernhof Bochum-Laer"
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#141414]/30 to-transparent" />
            <div className="absolute bottom-4 left-4 bg-[#141414]/80 px-3 py-2 border-l-2 border-[#D4A843]">
              <p
                className="text-[#D4A843] text-xs tracking-[0.2em] uppercase"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                Erbaut 1723
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex flex-col gap-6"
          >
            <p
              className="text-[#C1440E] text-xs tracking-[0.4em] uppercase"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Über den Hof
            </p>
            <h2
              className="text-4xl md:text-5xl font-light text-[#F2EDE8] leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              302 Jahre Geschichte. Kunst. Party. Mitten im Ruhrgebiet.
            </h2>
            <p
              className="text-[#A19D98] leading-relaxed text-sm md:text-base"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              1723 als Bauernhof erbaut. 2009 von Künstler Klaus Teichmann entdeckt und erworben.
              2010 zum Künstlerhof umgebaut – heute ist das Atelier 77 ein einzigartiger Ort für
              Freidenker und frei schaffende Künstler.
            </p>
            <blockquote
              className="border-l-2 border-[#D4A843] pl-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <p className="text-[#D4A843] italic text-xl md:text-2xl mb-2">
                "Raum für Freidenker und frei schaffende Künstler."
              </p>
              <cite
                className="text-[#A19D98] text-xs not-italic block"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                — Klaus Teichmann, Inhaber
              </cite>
            </blockquote>
            <Link
              to="/location"
              className="flex items-center gap-2 text-[#C1440E] hover:text-[#D4A843] text-xs tracking-[0.2em] uppercase transition-colors duration-200 w-fit"
              data-testid="location-teaser-link"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Die Location entdecken <ArrowRight size={13} />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
